module.exports = __webpack_public_path__ + "assets/img/a091152e4e2dfc5a4960f601e914ef2b.svg";